var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import { Pager as Component, PagerList } from './Table.styled';
import { getAutomation, getDebug } from '@citrus/runtime';
import { isNotNilOrEmpty } from '@pcty/utils';
import First from './private/pager/First';
import Previous from './private/pager/Previous';
import Next from './private/pager/Next';
import PageLinks from './private/pager/PageLinks';
import Last from './private/pager/Last';
import BackEllipsis from './private/pager/BackEllipsis';
import ForwardEllipsis from './private/pager/ForwardEllipsis';
import PageRange from './private/pager/PageRange';
var VERSION = '6.12.2';
var Pager = function (_a) {
    var automationId = _a.automationId, _b = _a.disabled, disabled = _b === void 0 ? false : _b, itemCount = _a.itemCount, onChangePage = _a.onChangePage, page = _a.page, pageSize = _a.pageSize, _c = _a.__TYPE, __TYPE = _c === void 0 ? 'Pager' : _c, other = __rest(_a, ["automationId", "disabled", "itemCount", "onChangePage", "page", "pageSize", "__TYPE"]);
    var _d = useState(calcPageCount(itemCount, pageSize)), pageCount = _d[0], setPageCount = _d[1];
    var numberOfVisiblePages = 5;
    useEffect(function () {
        setPageCount(calcPageCount(itemCount, pageSize));
    }, [itemCount, pageSize]);
    var goToPage = function (page, e) {
        if (isNotNilOrEmpty(e)) {
            e === null || e === void 0 ? void 0 : e.preventDefault();
            e === null || e === void 0 ? void 0 : e.stopPropagation();
        }
        onChangePage(page);
    };
    return (React.createElement(Component, __assign({}, other, getAutomation(automationId), getDebug(sessionStorage.getItem('citrus-debug') === 'true', __TYPE, VERSION)),
        React.createElement(First, { automationId: automationId, disabled: disabled, goToPage: goToPage, itemCount: itemCount, page: page, pageSize: pageSize }),
        React.createElement(Previous, { automationId: automationId, disabled: disabled, goToPage: goToPage, itemCount: itemCount, numberOfVisiblePages: numberOfVisiblePages, page: page, pageCount: pageCount, pageSize: pageSize }),
        React.createElement(PagerList, null,
            React.createElement(BackEllipsis, { automationId: automationId, disabled: disabled, goToPage: goToPage, itemCount: itemCount, numberOfVisiblePages: numberOfVisiblePages, page: page, pageCount: pageCount }),
            React.createElement(PageLinks, { automationId: automationId, disabled: disabled, goToPage: goToPage, itemCount: itemCount, numberOfVisiblePages: numberOfVisiblePages, page: page, pageCount: pageCount, pageSize: pageSize }),
            React.createElement(ForwardEllipsis, { automationId: automationId, disabled: disabled, goToPage: goToPage, itemCount: itemCount, numberOfVisiblePages: numberOfVisiblePages, page: page, pageCount: pageCount })),
        React.createElement(Next, { automationId: automationId, disabled: disabled, goToPage: goToPage, itemCount: itemCount, numberOfVisiblePages: numberOfVisiblePages, page: page, pageCount: pageCount, pageSize: pageSize }),
        React.createElement(Last, { automationId: automationId, disabled: disabled, goToPage: goToPage, itemCount: itemCount, page: page, pageCount: pageCount, pageSize: pageSize }),
        React.createElement(PageRange, { automationId: automationId, disabled: disabled, itemCount: itemCount, page: page, pageCount: pageCount, pageSize: pageSize })));
};
var calcPageCount = function (itemCount, pageSize) { return Math.ceil(itemCount / pageSize); };
Pager.defaultProps = {
    __TYPE: 'Pager',
};
export default Pager;
